<template>
    <div class="person-right">
        <div class="maintop">
            <span>在线缴费</span>
            <ul class="maintop-menu">
                <li :class="currentNav===1?'active1':'normal'" @click="showChange(1)">待缴账单({{nonPayedList.length}})</li>
                <li :class="currentNav===2?'active1':'normal'" @click="showChange(2)">已缴账单({{payedList.length}})</li>
            </ul>
        </div>
        <el-divider></el-divider>
        <div v-if="currentNav === 1">
            <div style="color:red" v-if="nonPayedList.length <= 0">
                当前没有需要缴费的项目！
            </div>
            <el-table v-else :data="nonPayedList" stripe style="width: 100%;margin-top:32px;border: 1px solid #E5E5E5;">
                <el-table-column prop="contractNo" label="合同编号" width="160">
                </el-table-column>
                <el-table-column prop="terms" label="期数" width="100">
                    <template slot-scope="scope">
                        <span>
                            第
                            {{scope.row.terms}}
                            期
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="roomAddress" label="租赁位置">
                </el-table-column>
                <el-table-column prop="date" label="费用时间区间" width="200">
                </el-table-column>
                <el-table-column prop="totalMoney" label="应缴金额(元)" width="120">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.totalMoney }}
                        </span>
                        <el-tooltip v-if="checkIsFirstTerm(scope.row.terms)" class="item" effect="dark" placement="top">
                            <div slot="content">{{feeTipMsg}}</div>
                            <i class='el-icon-question'></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column width="150">
                    <template slot-scope="scope">
                        <el-button size="mini"
                                   type="primary"
                                   :disabled="!canPay"
                                   v-if="scope.row.status == 0"
                                   @click="handle(scope.$index, scope.row)">缴费</el-button>
                        <el-button v-else :disabled="true" size="mini" type="info">代扣中</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-else>
            <div style="color:red" v-if="payedList.length <= 0">
                当前没有已缴费信息！
            </div>
            <el-table v-else :data="payedList" stripe style="width: 100%;margin-top:32px;border: 1px solid #E5E5E5;">
                <el-table-column prop="contractNo" label="合同编号" width="160">
                </el-table-column>
                <el-table-column prop="terms" label="期数" width="100">
                    <template slot-scope="scope">
                        <span>
                            第
                            {{scope.row.terms}}
                            期
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="roomAddress" label="租赁位置">
                </el-table-column>
                <el-table-column prop="date" label="费用时间区间" width="180">
                </el-table-column>
                <el-table-column prop="totalMoney" label="已缴金额(元)" width="120">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.totalMoney }}
                        </span>
                        <el-tooltip v-if="checkIsFirstTerm(scope.row.terms)" class="item" effect="dark" placement="top">
                            <div slot="content">{{feeTipMsg2}}</div>
                            <i class='el-icon-question'></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="payedDate" label="缴费时间" width="160">
                    <template slot-scope="scope">
                        <span>
                            {{scope.row.payedDate}}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <Payment v-if="showPayment" ref="payment" @refreshDataList="init"></Payment>

        <el-dialog id="account-pwd"
                   title=""
                   :visible.sync="warnningShow"
                   width="20%"
                   :center="false"
                   top="20vh"
                   :close-on-click-modal="false"
                   :lock-scroll="false">
            <el-form>
                <el-row>
                    <div>
                        <img :src="require('../../assets/imgs/code_ico1.jpg')" style="width:100%;height:100%;" />
                    </div>
                </el-row>
                <el-row>
                    <span style="font-weight: bold;font-size: 16px; color: red;margin-left: 20px;">请扫码关注公众号并完成相应的业务操作!</span>
                </el-row>
                <el-row>
                    <el-col>
                        <el-button type="primary" style="width: 100%;margin-top:15px;" @click="closeWarn()">关 闭</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import UserApi from "@/api/user/index";
    import Payment from './Payment'
    export default {
        data() {
            return {
                currentNav: 1,
                nonPayedList: [],
                payedList: [],
                feeTipMsg: "",
                feeTipMsg2: "",
                showPayment: false,
                canPay: true,
                warnningShow: false
            }
        },
        components: {
            Payment
        },
        methods: {
            showChange(id) {
                this.currentNav = id
            },
            getNoPayedList() {
                var vm = this;
                UserApi.getNoPayedList()
                    .then(
                        (res) => {
                            this.nonPayedList = res.data
                            for (var i = 0; i < this.nonPayedList.length; i++) {
                                this.nonPayedList[i].date = this.$moment(this.nonPayedList[i].beginDate).format('YYYY-MM-DD') + '~' + this.$moment(this.nonPayedList[i].endDate).format('YYYY-MM-DD')
                            }

                            if (this.nonPayedList != null) {
                                var term = "";
                                var index = -1;
                                this.nonPayedList.forEach(function (item, i) {
                                    if (item.terms.indexOf('-') > 0) {
                                        term = item.terms.split('-')[0];
                                    }
                                    else {
                                        term = item.terms;
                                    }

                                    // 这些期数中，是否存在代扣中的，如果有，则其它所有期都不能支付
                                    if (item.status == 1) {
                                        vm.canPay = false;
                                    }

                                    // 找到第1期就退出
                                    if (term == "1") {
                                        index = i;
                                        return false;
                                    }
                                    else if (parseInt(term) > 1) {
                                        return false;
                                    }
                                });

                                if (index >= 0) {
                                    var item = this.nonPayedList[index];
                                    this.feeTipMsg = "首期费用包含:";
                                    this.feeTipMsg += "租金：" + item.needMoney + "元；";
                                    this.feeTipMsg += "签约保证金：" + item.depositFee + "元；";
                                    this.feeTipMsg += "物业押金：" + item.propertyFee + "元";
                                }
                            }
                        },
                        (err) => {
                            this.$message({
                                message: err,
                                center: true,
                                type: "error"
                            });
                        }
                    )
                    .catch((error) => {
                        this.$message({
                            message: error,
                            center: true,
                            type: "error"
                        });
                    });
            },
            getPayedList() {
                UserApi.getPayedList()
                    .then(
                        (res) => {
                            this.payedList = res.data
                            for (var i = 0; i < this.payedList.length; i++) {
                                this.payedList[i].date = this.$moment(this.payedList[i].beginDate).format('YYYY-MM-DD') + '~' + this.$moment(this.payedList[i].endDate).format('YYYY-MM-DD')
                            }

                            if (this.payedList != null) {
                                var term = "";
                                var index = -1;
                                this.payedList.forEach(function (item, i) {
                                    if (item.terms.indexOf('-') > 0) {
                                        term = item.terms.split('-')[0];
                                    }
                                    else {
                                        term = item.terms;
                                    }

                                    // 找到第1期就退出
                                    if (term == "1") {
                                        index = i;
                                        return false;
                                    }
                                    else if (parseInt(term) > 1) {
                                        return false;
                                    }
                                });

                                if (index >= 0) {
                                    var item = this.payedList[index];
                                    this.feeTipMsg2 = "首期费用包含:";
                                    this.feeTipMsg2 += "租金：" + item.realMoney + "元；";
                                    this.feeTipMsg2 += "签约保证金：" + item.depositFee + "元；";
                                    this.feeTipMsg2 += "物业押金：" + item.propertyFee + "元";
                                }
                            }
                        },
                        (err) => {
                            this.$message({
                                message: err,
                                center: true,
                                type: "error"
                            });
                        }
                    )
                    .catch((error) => {
                        this.$message({
                            message: error,
                            center: true,
                            type: "error"
                        });
                    });
            },
            closeWarn() {
                this.warnningShow = false
            },
            // handle() {
            //     this.warnningShow = true
            // },
            handle(index, row) {
                // 必须按照顺序支付
                if(index > 0){
                    // 判断是否有多个合同
                    // 如果是相同合同的，则提示必须按顺序支付
                    if(this.nonPayedList[index - 1].contractNo == this.nonPayedList[index].contractNo){
                        this.$alert('必须按期数顺序支付！', '系统提醒', {
                            confirmButtonText: '确定'
                        });
                        return;
                    }
                }

                // 根据行找出待缴费实体
                this.showPayment = true
                this.$nextTick(() => {
                    this.$refs.payment.showPayment = true
                    this.$refs.payment.payData = row
                })
            },
            checkIsFirstTerm(terms) {
                if (terms.indexOf('-') > 0) {
                    if (terms.split('-')[0] == "1") {
                        return true;
                    }
                }
                else if (terms == "1") {
                    return true;
                }
                return false;
            },
            init() {
                this.getNoPayedList();
                this.getPayedList();
            }
        },
        activated() {
            this.init();
        }
    }
</script>

<style scoped>
    .el-divider {
        margin: 0;
    }

    .maintop-menu {
        list-style: none;
        padding: 0px;
        margin: 0px 4px 0 18px;
        height: 26px;
        line-height: 26px;
    }

    .maintop-menu .normal {
        float: left;
        margin-left: 35px;
        cursor: pointer;
        color: #999999;
    }

    .active1 {
        float: left;
        margin-left: 35px;
        cursor: pointer;
        color: #333333;
        border-bottom: 2px solid #2C79CB;
    }
</style>